import React, {useEffect, useState, useRef} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {Autocomplete, Button, CircularProgress, createFilterOptions, TextField} from '@mui/material';
import '../../App.css';
import '../create-json/CreateJson.css';
import {ErrorNotification} from "../error-notification/ErrorNotification";
import {SuccessNotification} from "../success-notification/SuccessNotification";
import {ConfirmDialog} from "../confirm-dialog/ConfirmDialog";
import useAxiosPrivate from '../../context/useAxiosPrivate';



export const CreateJson = (props) => {
  const refNamesContainer = useRef([]);
  const refInputValues = useRef([]);
  const [usersList, setUsersList] = useState([]);
  const [idList, setIdList] = useState([]);
  const [licenseKey, setLicenseKey] = useState('');
  const [json, setJson] = useState('');
  const [licenceKeysList, setLicenceKeysList] = useState([]);
  const axiosPrivate = useAxiosPrivate();

  const [openKeysList, setOpenKeysList] = useState(false);
  const loadKeysList = openKeysList && licenceKeysList.length === 0;

  const [openUsersList, setOpenUsersList] = useState(false);
  const loadUsersList = openUsersList && usersList.length === 0;

  const navigate = useNavigate();

    const [chosenUsers, setChosenUsers] = useState([]);
  const [allowDataTransfer, setAllowDataTransfer] = useState(false);
  const [factories, setFactories] = useState(null);
  const factoriesList = useRef();

    // Новые состояния для управления конфигурациями
  const [selectedUserId, setSelectedUserId] = useState('');
  const [userConfigurations, setUserConfigurations] = useState([]); // Список конфигураций пользователя
  const [loadingConfigurations, setLoadingConfigurations] = useState(false);
  const [addingConfiguration, setAddingConfiguration] = useState(false);
  const [selectedConfiguration, setSelectedConfiguration] = useState(null); // Выбранная конфигурация для редактирования
  const [configurationType, setConfigurationType] = useState('Material'); // Тип конфигурации: Material, Menu, Bundle
  
      // Состояния для Autocomplete выбора пользователя
  const [openUserSelect, setOpenUserSelect] = useState(false);
  const loadUserSelect = openUserSelect && usersList.length === 0;
  
  // Состояния для загрузки данных конфигурации
  const [loadingConfigurationData, setLoadingConfigurationData] = useState(false);
  const [configurationData, setConfigurationData] = useState(null);
  
    // Состояние для отображения ошибок
  const [error, setError] = useState(null);
  
    // Состояние для отслеживания синхронизации с сервером
    const [syncingVersion, setSyncingVersion] = useState(null); // {userId, modelId, version}
  
    // Состояние для успешных уведомлений
    const [successMessage, setSuccessMessage] = useState(null);

    // Состояние для confirm-диалога
  const [confirmDialog, setConfirmDialog] = useState(null); // {title, message, onConfirm}
  
  // Состояния для маппинга пользователь -> завод
  const [userFactoryMap, setUserFactoryMap] = useState({}); // userId -> {factoryId, factoryName}
  const [loadingFactoryMap, setLoadingFactoryMap] = useState(false);
  const [copyingConfigToFactory, setCopyingConfigToFactory] = useState(null); // {modelId, factoryId}


  useEffect(() => {
    getFactories();
  }, []);

  useEffect(() => {
    let active = true;

    if (!loadKeysList) {
      return undefined;
    }

    (async () => {
      if (active) {
        await getData();
      }
    })();

    return () => {
      active = false;
    };
  }, [loadKeysList]);

  useEffect(() => {
    if (!openKeysList) {
      setLicenceKeysList([]);
    }
  }, [openKeysList]);


  useEffect(() => {
    let active = true;

    if (!loadUsersList) {
      return undefined;
    }

    (async () => {
      if (active) {
        await getData();
      }
    })();

    return () => {
      active = false;
    };
  }, [loadUsersList]);

    useEffect(() => {
    if (!openUsersList) {
      setUsersList([]);
    }
  }, [openUsersList]);

  // Эффект для загрузки пользователей при открытии Autocomplete в разделе конфигураций
  useEffect(() => {
    let active = true;

    if (!loadUserSelect) {
      return undefined;
    }

    (async () => {
      if (active) {
        await getData();
      }
    })();

    return () => {
      active = false;
    };
  }, [loadUserSelect]);

    useEffect(() => {
    if (!openUserSelect) {
      // Не очищаем список пользователей, чтобы он сохранялся для повторного использования
    }
  }, [openUserSelect]);

  // Эффект для загрузки данных конфигурации при изменении типа или выбранной конфигурации
  useEffect(() => {
    if (selectedConfiguration && configurationType) {
      loadConfigurationData(selectedConfiguration.modelId);
    }
  }, [selectedConfiguration, configurationType]);

  const getDisabledCondition = licenseKey === null || licenseKey.trim() === '';
  const updateDisabledCondition = json === null || (typeof json === "string" && json.trim() === '')
    || refInputValues.current.length === 0;

  const getData = async () => {
    await axiosPrivate.get('/Users')
    .then((res) => {
      const data = res.data;
      const enabledOptionsTokens = data.filter(user => {
        return (!(user.deviceToken === null));
      });
      const resultTokens = enabledOptionsTokens.map(user => user.deviceToken);
      setLicenceKeysList(resultTokens);

      const enabledOptionsUsers = data.filter(user => {
        return (!(user.name === null));
      });

      const resultUsersNames = enabledOptionsUsers.map(user => {
        return user.name;
      });
      setUsersList(resultUsersNames);

      const resultIdList = enabledOptionsUsers.map(user => {
        return user.id;
      });
      setIdList(resultIdList);
        })
    .catch( (e) => { 
      console.error("getData error ", e);
      setError("Ошибка при загрузке данных пользователей");
    } );
  };

  const getFactories = async () => {
    await axiosPrivate.get('/Users/Factory')
      .then((res) => {
        setFactories(res.data);
        console.log("factories: ", res.data)
        factoriesList.current = res.data.map(factory => `завод ${factory.factory}`)
        console.log("factories list: ", factoriesList)
            })
      .catch( (e) => { 
        console.error("getFactories error ", e);
        setError("Ошибка при загрузке списка заводов");
      } );
  }

  const getDataFromServer = (pathDefinition) => {
    axiosPrivate.get(`/UserAdministration/${pathDefinition}/${licenseKey}`)
      .then((res) => {
        pathDefinition === "Notification" ? setJson(res.data.content) : setJson(JSON.stringify(res.data));
            })
      .catch(e => {
        console.error("Error getting data from server:", e);
        setError(e.response?.data?.message || "Ошибка при получении данных");
      });
  };

  const transferDataToUsers = (pathDefinition) => {
    let allRequests;
    if (pathDefinition === "Notification") {
      const newNotification = {
        title: "",
        jsonObject: json
      }
      allRequests = refInputValues.current.map((id, index) => {
        return axiosPrivate.post(`/UserAdministration/${pathDefinition}/${id}`, newNotification)
      });
    } else {
      allRequests = refInputValues.current.map((id, index) => {
        return axiosPrivate.put(`/UserAdministration/${pathDefinition}/${id}`, {"jsonObject": JSON.parse(json)})
      });
    }

    Promise.allSettled(allRequests)
      .then((res) => {
        const transferResult = res.map((user) => {
          let indexUser = null;
          for (let i = 0; i < refInputValues.current.length; i++) {
            if (user.value.data.userId === refInputValues.current[i]) {
              indexUser = i;
              break;
            }
          }
          return `\n${refNamesContainer.current[indexUser]}: ${user.value.statusText}`// value.
        });
                // Не показываем alert, результат виден по обновлению данных
      })
      .catch(e => {
        console.error("Error transferring data to users:", e);
        setError(e.response?.data?.message || "Ошибка при отправке данных пользователям");
      })
  };

  const getUsersByFactoryId = async (chosenFactoryId) => {
    console.log("chosen factory id: ", chosenFactoryId)
    await axiosPrivate.get(`/Users/GetByFactory/${chosenFactoryId}`)
      .then((res) => {
        let data = res.data;
        let newUsers = data.filter(item => {
          if (Array.isArray(item.users)) {
            return item.users
          }
        })
        let array1 = []
        let array2 = []
        newUsers.forEach((company) => {
          company.users.forEach((userObj) => {
            array1.push(userObj.id);
            array2.push(userObj.name);
          })
        })

        array1.forEach(array1Item => !refInputValues.current.includes(array1Item) && refInputValues.current.push(array1Item));
        array2.forEach(array2Item => !refNamesContainer.current.includes(array2Item) && refNamesContainer.current.push(array2Item));



        setChosenUsers(refNamesContainer.current)
        refNamesContainer.current.length > 0 ? setAllowDataTransfer(true) : setAllowDataTransfer(false)
            })
      .catch( (e) => { 
        console.error("getUsersByFactoryId error ", e);
        setError("Ошибка при загрузке пользователей завода");
      } );
  }

  const onChangeInputUsers = (event, newValue) => {
    if (newValue.find(option => option === "Выбрать всех...")) {
      refInputValues.current = [];
      refInputValues.current = idList;
      refNamesContainer.current = [];
      usersList.forEach((value) => refNamesContainer.current.push(value));
      setChosenUsers(refNamesContainer.current);
    }
    else if (newValue.find(option => option.includes('завод'))) {
      let chosenFactoryName = newValue.find(option => option.includes('завод'));
      chosenFactoryName = chosenFactoryName.split(' ').splice(1).join(' ');
      const chosenFactory = factories.find((factory) => factory.factory === chosenFactoryName)
      getUsersByFactoryId(chosenFactory.id)
    }
    else if (newValue) {
      refNamesContainer.current = newValue;
      const matchResults = [];
      for (let i = 0; i < refNamesContainer.current.length; i++) {
        for (let j = 0; j < usersList.length; j++) {
          if (refNamesContainer.current[i] === usersList[j]) {
            matchResults[i] = idList[j];
            break
          }
        }
      }
      refInputValues.current = matchResults;
      setChosenUsers(refNamesContainer.current)
    } else {
      refNamesContainer.current = [];
    }
        refNamesContainer.current.length > 0 ? setAllowDataTransfer(true) : setAllowDataTransfer(false)
  }

    // Функции для управления конфигурациями
  const loadUserConfigurations = async (userId) => {
    if (!userId) return;
    
    setLoadingConfigurations(true);
        try {
      const response = await axiosPrivate.get(`/UserAdministration/AvailableVersions/${userId}`);
      // Гарантируем, что у каждой конфигурации есть поле isActive
      const configurations = response.data.map(config => ({
        ...config,
        isActive: config.isActive === true
      }));
      setUserConfigurations(configurations);
        } catch (error) {
      console.error("Error loading configurations:", error);
      setError("Ошибка при загрузке конфигураций пользователя");
    } finally {
      setLoadingConfigurations(false);
    }
  };

  const addConfiguration = async (userId) => {
    if (!userId) return;
    
    setAddingConfiguration(true);
    try {
      // Добавляем дефолтную конфигурацию
      await axiosPrivate.post(`/UserAdministration/AddModel/${userId}`);
      
      // Обновляем список конфигураций
      await loadUserConfigurations(userId);
      
              // Не показываем alert, успех виден по обновлению списка конфигураций
    } catch (error) {
      console.error("Error adding configuration:", error);
      setError("Ошибка при добавлении конфигурации");
    } finally {
      setAddingConfiguration(false);
    }
  };

    const updateConfiguration = async (userId, modelId) => {
    if (!userId || !modelId || !json) return;
    
    try {
      // Определяем endpoint в зависимости от типа конфигурации
      let endpoint = '';
      switch(configurationType) {
        case 'Material':
          endpoint = `Material/${userId}?modelId=${modelId}`;
          break;
        case 'Menu':
          endpoint = `Menu/${userId}?modelId=${modelId}`;
          break;
        case 'Bundle':
          endpoint = `Bundle/${userId}?modelId=${modelId}`;
          break;
        default:
          endpoint = `Material/${userId}?modelId=${modelId}`;
      }
      
      // Отправляем обновление конфигурации
      await axiosPrivate.put(`/UserAdministration/${endpoint}`, {
        jsonObject: JSON.parse(json)
      });
      
            // Не показываем alert, успех виден по обновлению данных
    } catch (error) {
      console.error("Error updating configuration:", error);
      setError("Ошибка при обновлении конфигурации");
    }
  };

    // Функция для установки активной версии
  const setActiveVersion = async (userId, modelId) => {
    if (!userId || !modelId) return;
    
    // Находим информацию о версии для индикатора
    const configInfo = userConfigurations.find(c => c.modelId === modelId);
    
    // Устанавливаем состояние синхронизации
    setSyncingVersion({
      userId,
      modelId,
      version: configInfo?.version || `ID: ${modelId}`
    });
    
    try {
      await axiosPrivate.put(`/UserAdministration/SetActiveModel/${userId}/${modelId}`);
      
      // Обновляем список конфигураций, чтобы отразить новую активную версию
      setUserConfigurations(prev => {
        return prev.map(config => ({
          ...config,
          isActive: config.modelId === modelId
        }));
      });
      
      // Не показываем alert, успех виден по обновлению списка
    } catch (error) {
      console.error("Error setting active version:", error);
      setError("Ошибка при установке активной версии");
    } finally {
      // Сбрасываем индикатор синхронизации через небольшую задержку
      setTimeout(() => {
        setSyncingVersion(null);
      }, 1000);
    }
  };

    const handleConfigurationSelect = (config) => {
    setSelectedConfiguration(config);
    // Сбрасываем данные конфигурации при выборе новой
    setConfigurationData(null);
  };

  // Функция для загрузки данных конфигурации по modelId
  const loadConfigurationData = async (modelId) => {
    if (!modelId || !configurationType) return;
    
    setLoadingConfigurationData(true);
    try {
      const response = await axiosPrivate.get(`/UserAdministration/ModelById/${modelId}`);
      
      if (response.data && response.data.length > 0) {
        const configData = response.data[0];
        setConfigurationData(configData);
        
        // В зависимости от выбранного типа конфигурации, загружаем соответствующие данные в textarea
        let dataToShow = '';
        switch(configurationType) {
          case 'Material':
            dataToShow = configData.material || '';
            break;
          case 'Menu':
            dataToShow = configData.menu || '';
            break;
          case 'Bundle':
            dataToShow = configData.bundleInfo || '';
            break;
          default:
            dataToShow = configData.material || '';
        }
        
        // Форматируем JSON для отображения
        try {
          const parsedData = JSON.parse(dataToShow);
          setJson(JSON.stringify(parsedData, null, 2));
        } catch (e) {
          // Если не JSON, отображаем как есть
          setJson(dataToShow);
        }
      }
        } catch (error) {
      console.error("Error loading configuration data:", error);
      setError("Ошибка при загрузке данных конфигурации");
    } finally {
      setLoadingConfigurationData(false);
    }
  };

    // Функция для получения имени пользователя по ID
  const getUserNameById = (userId) => {
    const index = idList.findIndex(id => id === userId);
    return index !== -1 ? usersList[index] : `Пользователь ${userId}`;
  };

  // Функция для построения маппинга userId -> завод
  const buildUserFactoryMap = async () => {
    if (!factories || factories.length === 0) return;
    
    setLoadingFactoryMap(true);
    const newMap = {};
    
    try {
      // Для каждого завода получаем его пользователей
      for (const factory of factories) {
        try {
          const response = await axiosPrivate.get(`/Users/GetByFactory/${factory.id}`);
          const data = response.data || [];
          
          data.forEach((company) => {
            if (Array.isArray(company.users)) {
              company.users.forEach((userObj) => {
                newMap[userObj.id] = {
                  factoryId: factory.id,
                  factoryName: factory.factory
                };
              });
            }
          });
        } catch (e) {
          console.error(`buildUserFactoryMap error for factory ${factory.id}:`, e);
        }
      }
      
      setUserFactoryMap(newMap);
      console.log("userFactoryMap построен:", newMap);
    } catch (e) {
      console.error("buildUserFactoryMap error:", e);
    } finally {
      setLoadingFactoryMap(false);
    }
  };

  // Загружаем маппинг пользователь-завод после получения списка заводов
  useEffect(() => {
    if (factories && factories.length > 0) {
      buildUserFactoryMap();
    }
  }, [factories]);

  // Функция для получения названия завода по ID пользователя
  const getFactoryNameByUserId = (userId) => {
    const factoryInfo = userFactoryMap[userId];
    return factoryInfo ? factoryInfo.factoryName : null;
  };

  // Функция для копирования конфигурации всем пользователям завода
  const addConfigurationToAllFactoryUsers = async (userId, configModelId) => {
    if (!userId || !configModelId) return;
    
    const factoryInfo = userFactoryMap[userId];
    if (!factoryInfo) {
      setError("Не удалось определить завод пользователя");
      return;
    }
    
    const { factoryId, factoryName } = factoryInfo;
    setCopyingConfigToFactory({ modelId: configModelId, factoryId });
    
        try {
          // Вызываем единый API для добавления конфигурации всем пользователям завода
          const response = await axiosPrivate.post(`/UserAdministration/AddModelToFactoryUsers/${configModelId}/${factoryId}`);
      
          const message = typeof response.data === 'string' 
            ? response.data 
            : `Конфигурация добавлена пользователям завода "${factoryName}"`;
      
          setSuccessMessage(message);
      
    } catch (e) {
      console.error("addConfigurationToAllFactoryUsers error:", e);
      setError("Ошибка при добавлении конфигурации пользователям завода");
    } finally {
      setCopyingConfigToFactory(null);
    }
  };

  return (
    <div className='json-container'>
      <div className='control-container'>
        <div className="search-keys-wrapper">
          <Autocomplete
            className="search-keys"
            open={openKeysList}
            value={licenseKey}
            onChange={(event, newValue) => {
              setLicenseKey(newValue);
            }}
            onOpen={() => {
              setOpenKeysList(true);
            }}
            onClose={() => {
              setOpenKeysList(false);
            }}
            freeSolo
            forcePopupIcon={true}
            isOptionEqualToValue={(option, value) => option.key === value.key}
            getOptionLabel={(option) => typeof option === 'string'
            || option instanceof String ? option : ""}
            options={licenceKeysList}
            loading={loadKeysList}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Введите license key"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loadKeysList ? <CircularProgress color="inherit" size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
              />
            )}
          />
        </div>

        <div className={props.userRole.roleId > 1 ? 'app-element-off' : 'json-edit-buttons'}>
          <Button className='save-button' disabled={getDisabledCondition}
                  variant="outlined" onClick={() => getDataFromServer("Catalog")}>
            Получить Catalog
          </Button>
          <Button className='save-button' disabled={getDisabledCondition}
                  variant="outlined" onClick={() => getDataFromServer("Menu")}>
            Получить MenuList
          </Button>
          <Button className='save-button' disabled={getDisabledCondition}
                  variant="outlined" onClick={() => getDataFromServer("Bundle")}>
            Получить Bundle
          </Button>
        </div>
          <Button className='save-button' disabled={getDisabledCondition}
                  variant="outlined" onClick={() => getDataFromServer("Notification")}>
            Получить notifications
          </Button>

          <Button
            className='save-button'
            variant="outlined"
            onClick={() => {navigate('/')}}
            >
            {"Вернуться на страницу"}
          </Button>

          <Link to="/add-json/default-configuration">
            <Button
              className='save-button'
              variant="outlined"
            >
              {"Установить базовую конфигурацию"}
            </Button>
          </Link>


      </div>

      <textarea className='textarea' wrap="soft" value={json} rows="30"
        onChange={e => {setJson(e.target.value)}}></textarea>

      <div className='control-container'>
        <div className="search-users-wrapper">
          {/*<Autocomplete*/}
          {/*  multiple*/}
          {/*  disableCloseOnSelect={true}*/}
          {/*  limitTags={1}*/}
          {/*  className="search-users"*/}
          {/*  open={openUsersList}*/}
          {/*  onChange={(event, newValue) => {*/}
          {/*    if (newValue !== null) {*/}
          {/*      refNamesContainer.current = newValue;*/}
          {/*      const matchResults = [];*/}
          {/*      for (let i = 0; i < refNamesContainer.current.length; i++) {*/}
          {/*        for (let j = 0; j < usersList.length; j++) {*/}
          {/*          if (refNamesContainer.current[i] === usersList[j]) {*/}
          {/*            matchResults[i] = idList[j];*/}
          {/*            break*/}
          {/*          }*/}
          {/*        }*/}
          {/*      }*/}
          {/*      refInputValues.current = matchResults;*/}
          {/*    } else {*/}
          {/*      refNamesContainer.current = [];*/}
          {/*    }*/}
          {/*  }}*/}

          {/*  onOpen={() => {*/}
          {/*    setOpenUsersList(true);*/}
          {/*  }}*/}
          {/*  onClose={() => {*/}
          {/*    setOpenUsersList(false);*/}
          {/*  }}*/}
          {/*  freeSolo*/}
          {/*  forcePopupIcon={true}*/}
          {/*  options={usersList}*/}
          {/*  loading={loadUsersList}*/}
          {/*  renderInput={(params) => (*/}
          {/*    <TextField*/}
          {/*      {...params}*/}
          {/*      label="Введите user name"*/}
          {/*      placeholder="Users"*/}
          {/*      InputProps={{*/}
          {/*        ...params.InputProps,*/}
          {/*        endAdornment: (*/}
          {/*          <React.Fragment>*/}
          {/*            {loadUsersList ? <CircularProgress color="inherit" size={20} /> : null}*/}
          {/*            {params.InputProps.endAdornment}*/}
          {/*          </React.Fragment>*/}
          {/*        ),*/}
          {/*      }}*/}
          {/*    />*/}
          {/*  )}*/}
          {/*/>*/}


          <Autocomplete
            // disabled={!listReadyToOpen.current}
            multiple
            limitTags={3}
            // className="input-users"
            className="search-users"
            open={openUsersList}
            value={chosenUsers}  // refNamesContainer.current
            disableCloseOnSelect
            // getOptionDisabled={(option) => {
            //   return option === "Выбрать всех..." || option === "завод veon"
            // }}
            filterOptions={(options, params) => {
              const filter = createFilterOptions();
              const filtered = filter(options, params);
              // return ['Выбрать всех...', ...factoriesList, ...filtered]
              return ['Выбрать всех...', ...factoriesList.current, ...filtered]
              // else {
              //   const filter = createFilterOptions();
              //   const filtered = filter(options, params);
              //   return [...filtered]
              // }
            }}
            onChange={(e, newValue) => {
              onChangeInputUsers(e, newValue)
            }}
            onOpen={() => {
              setOpenUsersList(true);
            }}
            onClose={() => {
              setOpenUsersList(false);
            }}
            freeSolo
            forcePopupIcon={true}
            options={usersList}
            loading={loadUsersList}
            renderInput={(params) => (
              <TextField
                {...params}
                style={{fontSize : "2vw"}}
                placeholder="Получатели"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loadUsersList ? <CircularProgress color="inherit" size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
              />
            )}
          />




        </div>


        <div className={props.userRole.roleId > 1 ? 'app-element-off' : 'json-edit-buttons'}>
          <Button className='save-button' disabled={updateDisabledCondition}
                  variant="outlined" onClick={() => transferDataToUsers("Material")}>
            Отправить Catalog
          </Button>

          <Button className='save-button' disabled={updateDisabledCondition}
                  variant="outlined" onClick={() => transferDataToUsers("Menu")}>
            Отправить MenuList
          </Button>

          <Button className='save-button' disabled={updateDisabledCondition}
                  variant="outlined" onClick={() => transferDataToUsers("Bundle")}>
            Отправить Bundle
          </Button>
        </div>
                <Button className='save-button' disabled={updateDisabledCondition}
                variant="outlined" onClick={() => transferDataToUsers("Notification")}>
          Отправить notifications
        </Button>
      </div>

      {/* Новый раздел для управления конфигурациями */}
      <div className="configurations-section" style={{
        marginTop: '20px',
        padding: '20px',
        border: '1px solid #ddd',
        borderRadius: '8px',
        backgroundColor: '#f9f9f9'
      }}>
        <h3 style={{marginBottom: '15px', color: '#333'}}>Управление конфигурациями пользователя</h3>
        
                        <div style={{display: 'flex', gap: '10px', marginBottom: '15px', flexWrap: 'wrap'}}>
          <Autocomplete
            style={{minWidth: '200px'}}
            open={openUserSelect}
            onOpen={() => {
              setOpenUserSelect(true);
            }}
            onClose={() => {
              setOpenUserSelect(false);
            }}
            options={usersList}
            getOptionLabel={(option) => option}
            loading={loadUserSelect}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Выберите пользователя"
                placeholder="Имя пользователя"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loadUserSelect ? <CircularProgress color="inherit" size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
              />
            )}
                        onChange={(event, newValue) => {
              if (newValue) {
                const index = usersList.findIndex(user => user === newValue);
                if (index !== -1) {
                  const userId = idList[index];
                  setSelectedUserId(userId);
                  setUserConfigurations([]);
                  setSelectedConfiguration(null);
                  setConfigurationData(null);
                  setJson(''); // Очищаем текстовое поле
                  loadUserConfigurations(userId);
                }
              } else {
                setSelectedUserId('');
                setUserConfigurations([]);
                setSelectedConfiguration(null);
                setConfigurationData(null);
                setJson(''); // Очищаем текстовое поле
              }
            }}
            clearOnBlur={false}
            autoComplete
            includeInputInList
          />
          
          <Button 
            variant="contained" 
            color="primary"
            disabled={!selectedUserId || addingConfiguration}
            onClick={() => addConfiguration(selectedUserId)}
          >
            {addingConfiguration ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              'Добавить конфигурацию'
            )}
          </Button>
        </div>
        
        {/* Список конфигураций пользователя */}
        {selectedUserId && (
          <div>
            <h4 style={{marginBottom: '10px'}}>
              Конфигурации пользователя: {getUserNameById(selectedUserId)}
            </h4>
            
            {loadingConfigurations ? (
              <div style={{textAlign: 'center', padding: '20px'}}>
                <CircularProgress />
                <p>Загрузка конфигураций...</p>
              </div>
            ) : userConfigurations.length > 0 ? (
              <div>
                                                                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                  gap: '6px',
                  marginBottom: '12px'
                }}>
                  {userConfigurations.map((config) => {
                    const isActive = config.isActive === true;
                    const isSelected = selectedConfiguration?.modelId === config.modelId;
                    
                                        return (
                                            <div 
                        key={config.modelId}
                        style={{
                          padding: '6px 8px',
                          border: `1px solid ${isActive ? '#4caf50' : '#ccc'}`,
                          borderRadius: '4px',
                          backgroundColor: isSelected ? '#e3f2fd' : (isActive ? '#f0f9f0' : 'white'),
                          cursor: 'pointer',
                          transition: 'background-color 0.2s, border-color 0.2s',
                          position: 'relative'
                        }}
                        onClick={() => handleConfigurationSelect(config)}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 
                          isSelected ? '#d4e7fd' : (isActive ? '#e8f5e9' : '#f5f5f5')
                        }
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 
                          isSelected ? '#e3f2fd' : (isActive ? '#f0f9f0' : 'white')
                        }
                      >
                        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '4px'}}>
                          <div>
                            <div style={{fontWeight: 'bold', fontSize: '0.75em'}}>ID: {config.modelId}</div>
                            <div style={{fontSize: '0.7em', color: '#666'}}>Версия: {config.version}</div>
                          </div>
                          
                          {isActive ? (
                            <span style={{
                              fontSize: '0.6em',
                              color: '#4caf50',
                              backgroundColor: '#e8f5e9',
                              padding: '1px 5px',
                              borderRadius: '8px',
                              fontWeight: 'bold'
                            }}>
                              активна
                            </span>
                          ) : (
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                setActiveVersion(selectedUserId, config.modelId);
                              }}
                              style={{
                                fontSize: '0.6em',
                                color: '#1565c0',
                                backgroundColor: '#e3f2fd',
                                border: '1px solid #90caf9',
                                borderRadius: '3px',
                                padding: '1px 6px',
                                cursor: 'pointer',
                                transition: 'background-color 0.2s',
                                whiteSpace: 'nowrap'
                              }}
                              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#bbdefb'}
                              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#e3f2fd'}
                            >
                              сделать активной
                            </button>
                          )}
                        </div>
                        
                                                {/* Кнопка добавления конфигурации всем пользователям завода */}
                        {userFactoryMap[selectedUserId] && (
                          <div style={{ marginTop: '6px', borderTop: '1px solid #e8e8e8', paddingTop: '6px' }}>
                            <button
                                                            onClick={(e) => {
                                e.stopPropagation();
                                const factoryName = userFactoryMap[selectedUserId]?.factoryName;
                                setConfirmDialog({
                                  title: 'Добавить конфигурацию заводу',
                                  message: `Добавить эту конфигурацию (ID: ${config.modelId}) ко всем пользователям завода "${factoryName}"?`,
                                  onConfirm: () => {
                                    setConfirmDialog(null);
                                    addConfigurationToAllFactoryUsers(selectedUserId, config.modelId);
                                  }
                                });
                              }}
                              disabled={copyingConfigToFactory?.modelId === config.modelId}
                              style={{
                                width: '100%',
                                fontSize: '0.6em',
                                color: '#5d4037',
                                backgroundColor: copyingConfigToFactory?.modelId === config.modelId ? '#efebe9' : '#efebe9',
                                border: '1px solid #d7ccc8',
                                borderRadius: '3px',
                                padding: '3px 6px',
                                cursor: copyingConfigToFactory?.modelId === config.modelId ? 'wait' : 'pointer',
                                transition: 'background-color 0.15s',
                                textAlign: 'center',
                                lineHeight: '1.2'
                              }}
                              onMouseEnter={(e) => {
                                if (copyingConfigToFactory?.modelId !== config.modelId) {
                                  e.currentTarget.style.backgroundColor = '#d7ccc8';
                                }
                              }}
                              onMouseLeave={(e) => {
                                if (copyingConfigToFactory?.modelId !== config.modelId) {
                                  e.currentTarget.style.backgroundColor = '#efebe9';
                                }
                              }}
                            >
                              {copyingConfigToFactory?.modelId === config.modelId ? (
                                'Копирование...'
                              ) : (
                                `Добавить ко всему заводу ${userFactoryMap[selectedUserId]?.factoryName || ''}`
                              )}
                            </button>
                          </div>
                        )}
                        
                                                {isActive && (
                          <div style={{
                            position: 'absolute',
                            bottom: '3px',
                            right: '5px',
                            fontSize: '0.55em',
                            color: '#4caf50',
                            fontStyle: 'italic'
                          }}>
                            текущая
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
                
                                {/* Управление выбранной конфигурацией */}
                {selectedConfiguration && (
                  <div style={{
                    padding: '15px',
                    border: '1px solid #3cb7ff',
                    borderRadius: '4px',
                    backgroundColor: '#f0f8ff',
                    marginTop: '10px'
                  }}>
                    <h5 style={{marginBottom: '10px'}}>
                      Редактирование конфигурации ID: {selectedConfiguration.modelId}
                    </h5>
                    
                    <div style={{display: 'flex', gap: '10px', marginBottom: '10px', alignItems: 'center'}}>
                      <div>
                        <label style={{marginRight: '5px'}}>Тип конфигурации:</label>
                        <select 
                          value={configurationType}
                          onChange={(e) => setConfigurationType(e.target.value)}
                          style={{
                            padding: '5px',
                            borderRadius: '4px',
                            border: '1px solid #ccc'
                          }}
                        >
                          <option value="Material">Material (Catalog)</option>
                          <option value="Menu">Menu</option>
                          <option value="Bundle">Bundle</option>
                        </select>
                      </div>
                      
                      <Button 
                        variant="contained" 
                        color="secondary"
                        disabled={!json || json.trim() === ''}
                        onClick={() => updateConfiguration(selectedUserId, selectedConfiguration.modelId)}
                      >
                        Обновить конфигурацию
                      </Button>
                    </div>
                    
                    <div style={{fontSize: '0.9em', color: '#666', marginBottom: '10px'}}>
                      <p>Текущая версия: <strong>{selectedConfiguration.version}</strong></p>
                      <p>Для обновления используйте JSON из текстового поля выше</p>
                      
                      {loadingConfigurationData ? (
                        <div style={{display: 'flex', alignItems: 'center', gap: '5px', marginTop: '5px'}}>
                          <CircularProgress size={16} />
                          <span>Загрузка данных конфигурации...</span>
                        </div>
                      ) : configurationData ? (
                        <div style={{marginTop: '5px'}}>
                          <p>Данные загружены. Редактируйте JSON выше и нажмите "Обновить конфигурацию"</p>
                          <div style={{
                            marginTop: '5px',
                            padding: '5px',
                            backgroundColor: '#f5f5f5',
                            borderRadius: '3px',
                            fontSize: '0.8em'
                          }}>
                            <div><strong>ID:</strong> {configurationData.id}</div>
                            <div><strong>User ID:</strong> {configurationData.userId}</div>
                            <div><strong>Active:</strong> {configurationData.isActive ? 'Да' : 'Нет'}</div>
                            <div><strong>Notifications:</strong> {configurationData.notifications?.length || 0}</div>
                          </div>
                        </div>
                      ) : (
                        <p style={{marginTop: '5px'}}>Выберите тип конфигурации для загрузки данных</p>
                      )}
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div style={{textAlign: 'center', padding: '20px', color: '#666'}}>
                Нет конфигураций для этого пользователя
              </div>
            )}
          </div>
        )}
        
                        <div style={{marginTop: '15px', fontSize: '0.9em', color: '#666'}}>
          <p><strong>Инструкция:</strong></p>
          <ol style={{paddingLeft: '20px', marginTop: '5px'}}>
            <li>Выберите пользователя из списка</li>
            <li>Нажмите "Добавить конфигурацию" для создания новой (дефолтной) конфигурации</li>
            <li>Выберите конфигурацию из списка для редактирования</li>
            <li>Выберите тип конфигурации (Material, Menu, Bundle) - данные автоматически загрузятся в текстовое поле</li>
            <li>Отредактируйте JSON в текстовом поле выше при необходимости</li>
            <li>Нажмите "Обновить конфигурацию" для сохранения изменений</li>
            <li><strong>Для смены активной версии:</strong> нажмите кнопку "сделать активной" на нужной конфигурации</li>
          </ol>
          <div style={{
            marginTop: '10px',
            padding: '10px',
            backgroundColor: '#f0f8ff',
            borderRadius: '4px',
            border: '1px solid #bbdefb'
          }}>
            <p style={{margin: '0 0 5px 0', fontWeight: 'bold', color: '#1976d2'}}>
              <strong>Визуальные обозначения:</strong>
            </p>
            <ul style={{margin: '0', paddingLeft: '20px'}}>
              <li><span style={{color: '#4caf50', fontWeight: 'bold'}}>Зелёная рамка и бейдж "активна"</span> - текущая активная версия</li>
              <li><span style={{color: '#2196f3', fontWeight: 'bold'}}>Кнопка "сделать активной"</span> - установить эту версию как активную</li>
              <li><span style={{color: '#1976d2', fontWeight: 'bold'}}>Синий фон</span> - выбранная для редактирования конфигурация</li>
            </ul>
          </div>
          <p style={{marginTop: '10px', fontStyle: 'italic'}}>
            <strong>Примечание:</strong> При смене типа конфигурации или выборе другой конфигурации 
            данные автоматически загружаются из API и отображаются в основном текстовом поле.
          </p>
        </div>
      </div>
      
            
      {/* Индикатор синхронизации с сервером */}
      {syncingVersion && (
        <div style={{
          position: 'fixed',
          top: '20px',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 99998,
          backgroundColor: '#1976d2',
          color: 'white',
          padding: '10px 20px',
          borderRadius: '4px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          animation: 'slideDown 0.3s ease-out'
        }}>
          <div style={{
            width: '16px',
            height: '16px',
            border: '2px solid rgba(255, 255, 255, 0.3)',
            borderTop: '2px solid white',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }}></div>
          <span>
            Устанавливается активная версия: <strong>{syncingVersion.version}</strong>
          </span>
        </div>
      )}
      
            {/* Confirm-диалог */}
            {confirmDialog && (
              <ConfirmDialog
                title={confirmDialog.title}
                message={confirmDialog.message}
                onConfirm={confirmDialog.onConfirm}
                onCancel={() => setConfirmDialog(null)}
                confirmText="Да"
                cancelText="Нет"
              />
            )}
      
            {/* Компонент для отображения ошибок */}
            {error && (
              <ErrorNotification
                message={error}
                duration={5000}
                onClose={() => setError(null)}
              />
            )}
      
            {/* Компонент для отображения успешных уведомлений */}
            {successMessage && (
              <SuccessNotification
                message={successMessage}
                duration={5000}
                onClose={() => setSuccessMessage(null)}
              />
            )}
    </div>
  )
}
